export default __webpack_public_path__ + "static/media/pinterest-icon.f8f16b55.svg";